const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

const { getElement } = window.BAO.Utils

class ComplementaryProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists && this.els?.thumbnail?.exists) return

    this.carousel = this.setupCarousel()
    this.setImages()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      document,
      'refreshMediaGallery',
      this.setImages.bind(this),
    )

    this.els.thumbnail.elements.forEach((thumbnail) => {
      this.listeners.add(thumbnail, 'click', this.onThumbClick.bind(this))
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden="true"])`,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: this.onSlideChanged.bind(this),
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  setImages () {
    const colour = getElement(
      '[form="product-form-complementary-product-popup"] [data-complementary-product-variant-radios-el="option-choice"]:checked',
    )

    const colourName = colour.value

    if (!colour && !colourName) {
      return
    }

    let visibleImages = 0

    this.els.slide.elements.forEach((image) => {
      let hidden = image.dataset.colour !== colourName

      const slide = image.dataset.slide

      const thumb = document.querySelector(
        `${this.els.thumbnail.selector}[data-slide='${slide}']`,
      )

      if (!image.hasAttribute('data-colour')) {
        hidden = false
      }

      image.setAttribute('aria-hidden', hidden ? 'true' : 'false')
      thumb.setAttribute('aria-hidden', hidden ? 'true' : 'false')

      if (!hidden) {
        image.setAttribute('data-index', visibleImages)
        thumb.setAttribute('data-index', visibleImages)
        visibleImages++
      } else {
        delete image.dataset.index
        delete thumb.dataset.index
      }
    })

    this.carousel.update(this.carousel.options, 0)
    this.carousel.track.init()

    this.els.thumbnail.elements.forEach((thumb) => {
      thumb.setAttribute(
        'aria-current',
        parseInt(thumb.dataset.index, 10) === 0,
      )
    })
  }

  onThumbClick (e) {
    const thumbnailTrigger = e.target.closest(`${this.els.thumbnail.selector}`)

    const targetIndex = parseInt(thumbnailTrigger.dataset.index, 10)

    this.carousel.moveToIdx(targetIndex)
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.thumbnail.elements.forEach((thumb) => {
      thumb.setAttribute(
        'aria-current',
        parseInt(thumb.dataset.index, 10) === currentSlide,
      )
    })
  }
}

if (!customElements.get('complementary-product-media')) {
  customElements.define(
    'complementary-product-media',
    ComplementaryProductMedia,
  )
}
